import { cn } from '@/lib/utils';
import { IconName } from '@/utils/iconName';
import React, {
  cloneElement,
  HTMLAttributes,
  ReactNode,
  ReactSVGElement,
  useCallback,
  useEffect,
  useState,
} from 'react';
// @ts-ignore
import FallbackIcon from '../../assets/icons/warning-triangle.svg?react';

interface PropsIconBase extends HTMLAttributes<SVGElement> {
  icon: ReactNode;
  color?: string;
  size?: number | string;
}

const IconBase = ({ icon, size, ...rest }: PropsIconBase) =>
  cloneElement(icon as ReactSVGElement, {
    width: size ?? 24,
    height: size ?? 24,
    ...rest,
  });

interface Props extends Omit<React.ComponentProps<typeof IconBase>, 'icon'> {
  name: IconName;
}

function SvgIcon({ name, ...props }: Props) {
  const icon = useDynamicSVGImport(name);
  const { className, ...rest } = props;
  return (
    <div className={cn('tw:flex tw:items-center tw:justify-center', className)}>
      <IconBase icon={icon ?? <FallbackIcon />} {...rest} />
    </div>
  );
}

const useDynamicSVGImport = (src: string) => {
  const [icon, setIcon] = useState<ReactNode | null>(null);

  const importIcon = useCallback(async () => {
    import(/* vite-ignore */ `../../assets/icons/${src}.svg?react`)
      .then((m) => {
        if (m?.default) {
          setIcon(m.default);
        }
      })
      .catch((e) => {
        console.error('Error importing icon', e);
      });
  }, [src]);

  useEffect(() => {
    importIcon();
  }, [importIcon]);

  return icon;
};

export default SvgIcon;
